import React from 'react';
import { Target } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

export default function PursuitMarker({ isInPursuit }) {
  if (!isInPursuit) return null;

  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-green-100 text-green-600 cursor-help">
            <Target className="w-3 h-3" />
          </span>
        </TooltipTrigger>
        <TooltipContent 
          side="top" 
          className="bg-[#0A1A2F] text-white border-0 shadow-lg p-2 z-[9999]"
        >
          <p className="text-xs">In Pursuit</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}